import React from "react";
import PropTypes from "prop-types";
import { Autocomplete, TextField } from "@mui/material";

const defaultGetOptionLabel = (o) =>
  typeof o === "string" ? o : String(o?.label ?? "");

/** Standard multi-select filter Autocomplete shared by bond filter grids. */
export default function FilterMultiAutocomplete({
  label,
  options,
  value,
  onChange,
  getOptionLabel,
  isOptionEqualToValue,
  renderOption,
  renderTags,
  disabled,
  sx,
}) {
  return (
    <Autocomplete
      multiple
      options={options ?? []}
      value={Array.isArray(value) ? value : []}
      onChange={(e, v) => onChange?.(v)}
      getOptionLabel={getOptionLabel ?? defaultGetOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      renderOption={renderOption}
      renderTags={renderTags}
      disabled={disabled}
      sx={sx}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
}

FilterMultiAutocomplete.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  getOptionLabel: PropTypes.func,
  isOptionEqualToValue: PropTypes.func,
  renderOption: PropTypes.func,
  renderTags: PropTypes.func,
  disabled: PropTypes.bool,
  sx: PropTypes.object,
};
